import axios from 'axios';
import React, { useContext, useEffect, useReducer } from 'react';
import { Chart } from 'react-google-charts';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import LoadingBox from '../../component/LoadingBox';
import MessageBox from '../../component/MessageBox';
import DbEnvironmentBadge from '../../component/DbEnvironmentBadge';
import { Store } from '../../Store';
import { getError } from '../../utils';
import { api } from '../../Api';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, summery: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};


const fmt = (n) => Number(n || 0).toLocaleString();

export default function DashboardScreen() {
  const [{ loading, summery, error }, dispatch] = useReducer(reducer, {
    loading: true,
    error: '',
  });
  const { state } = useContext(Store);
  const { userInfo } = state;
  // Topups are their own service, so they are their own small fetch. `rows` is
  // what Accounts has already verified and is now waiting on this admin. The
  // admin scope never counts pending (unverified) requests — those are still
  // with Accounts and do not appear to admins anywhere.
  const [topups, setTopups] = React.useState({
    verified: 0,
    verifiedAmount: 0,
    approvedAmount: 0,
    approvedCount: 0,
    rows: [],
  });

  useEffect(() => {
    const fetchTopups = async () => {
      try {
        const { data } = await axios.get(
          api + '/api/topup/queue?status=verified&pageSize=5&scope=admin',
          { headers: { Authorization: `Bearer ${userInfo.token}` } }
        );
        setTopups({
          verified: Number(data?.totals?.verified) || 0,
          verifiedAmount: Number(data?.totals?.byStatus?.verified?.amount) || 0,
          approvedAmount: Number(data?.totals?.approvedAmount) || 0,
          approvedCount: Number(data?.totals?.byStatus?.approved?.count) || 0,
          rows: Array.isArray(data?.rows) ? data.rows : [],
        });
      } catch (err) {
        /* the topup cards are a shortcut, not the dashboard — stay quiet */
      }
    };
    if (userInfo?.token) fetchTopups();
    const fetchData = async () => {
      try {
        const { data } = await axios.get(api + '/api/orders/summary', {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        console.log(data);
        dispatch({ type: 'FETCH_SUCCESS', payload: data });
      } catch (error) {
        dispatch({ type: 'FETCH_FAIL', payload: getError(error) });
      }
    };
    fetchData();
  }, [userInfo]);
  return (
    <div style={{ width: '87%', float: 'right' }}>
      <Helmet>
        <title>Admin Dashboard </title>
      </Helmet>
      <Container className="">
        <h1 className="my-3 text-center fp">Admin Dashboard</h1>
        {/* Which database this is. Shown before the numbers below, because it
            changes what those numbers mean and what an action here would cost. */}
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center', marginBottom: '1rem' }}>
          <DbEnvironmentBadge />
        </div>

        {/* Money that cannot move until this admin does something. It sits above
            everything else because it is the only thing on this page that is
            somebody waiting. */}
        {topups.verified ? (
          <Link
            to="/admin/topup?status=verified"
            className="d-flex align-items-center gap-2 mb-3 p-3 rounded text-decoration-none"
            style={{ background: '#dbeafe', color: '#1d4ed8', border: '1px solid #bfdbfe' }}
          >
            <i className="fa fa-hourglass-half fa-lg" aria-hidden="true"></i>
            <div className="flex-grow-1">
              <b>{fmt(topups.verified)} topup(s) waiting for your approval</b>
              <div className="small">
                BDT {fmt(topups.verifiedAmount)} verified by Accounts.
              </div>
            </div>
            <span className="fw-semibold">Review &rarr;</span>
          </Link>
        ) : null}
        {loading ? (
          <LoadingBox />
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <>
            <Row style={{ marginBottom: '1rem' }}>
              <Col md={4}>
                <div className="card text-bg-success mb-3">
                  <div className="card-header bg-success">Total Users</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.users && summery.users[0]
                        ? summery.users[0].numUsers
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="card text-bg-info mb-3">
                  <div className="card-header bg-info">Verified Users</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.users && summery.users
                        ? summery.verifiedUsers
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="card text-bg-danger mb-3">
                  <div className="card-header bg-danger">UnVerified Users</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.users && summery.users
                        ? summery.users[0].numUsers - summery.verifiedUsers
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <div className="card text-bg-danger mb-3">
                  <div className="card-header bg-danger">Pending Orders</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.unPaidOrders && summery.unPaidOrders[0]
                        ? summery.unPaidOrders[0].numOrders +
                          '  Orders || ৳' +
                          summery.unPaidOrders[0].totalSales
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="card text-bg-success mb-3">
                  <div className="card-header bg-success">Approved Orders</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.paidOrders && summery.paidOrders[0]
                        ? summery.paidOrders[0].numOrders +
                          '  Orders || ৳' +
                          summery.paidOrders[0].totalSales
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="card text-bg-info mb-3">
                  <div className="card-header bg-info">Total Orders</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.paidOrders && summery.paidOrders[0]
                        ? summery.paidOrders[0].numOrders +
                          summery.unPaidOrders[0].numOrders +
                          '  Orders '
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <div className="card text-bg-danger mb-3">
                  <div className="card-header bg-danger">Pending Withdraw</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.unPaidWithdraw && summery.unPaidWithdraw[0]
                        ? summery.unPaidWithdraw[0].numOrders +
                          '  Requests || ৳' +
                          summery.unPaidWithdraw[0].totalSales * 12
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="card text-bg-success mb-3">
                  <div className="card-header bg-success">
                    Approved Withdraw
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.paidWithdraw && summery.paidWithdraw[0]
                        ? summery.paidWithdraw[0].numOrders +
                          '  Requests || ৳' +
                          summery.paidWithdraw[0].totalSales * 12
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="card text-bg-info mb-3">
                  <div className="card-header bg-info">Total Withdraw</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {summery.paidOrders && summery.paidOrders[0]
                        ? summery.paidWithdraw[0].numOrders +
                          summery.unPaidWithdraw[0].numOrders +
                          '  Requests '
                        : 0}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
            {/* Topups — what Accounts has verified and what is approved, plus
                the queue itself, so an approval is one click from here. */}
            <Row>
              <Col md={6}>
                <div className="card text-bg-primary mb-3">
                  <div className="card-header bg-primary">Verified by Accounts — To Approve</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      {fmt(topups.verified)} Requests || ৳{fmt(topups.verifiedAmount)}
                    </h5>
                    <Link to="/admin/topup?status=verified" className="text-white small">
                      Approve the BDT &rarr;
                    </Link>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="card text-bg-success mb-3">
                  <div className="card-header bg-success">Topups Approved</div>
                  <div className="card-body">
                    <h5 className="card-title">
                      ৳{fmt(topups.approvedAmount)}
                    </h5>
                    <Link to="/admin/topup?status=approved" className="text-white small">
                      {fmt(topups.approvedCount)} added to Shopping Balance &rarr;
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            {topups.rows.length ? (
              <Card className="border-0 shadow-sm mb-3">
                <Card.Body className="py-2">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div className="text-uppercase text-muted small fw-semibold" style={{ letterSpacing: '0.06em' }}>
                      Waiting for you
                    </div>
                    <Link to="/admin/topup?status=verified" className="small text-decoration-none">
                      Open the queue &rarr;
                    </Link>
                  </div>
                  {topups.rows.map((row) => (
                    <Link
                      key={row._id}
                      to="/admin/topup?status=verified"
                      className="d-flex align-items-center gap-2 py-2 border-bottom text-decoration-none text-body"
                    >
                      <div className="fw-semibold" style={{ minWidth: 110 }}>৳{fmt(row.amountBdt)}</div>
                      <div className="flex-grow-1 text-truncate small">
                        {row.name} <span className="text-muted">@{row.username}</span>
                        <span className="text-muted text-capitalize">
                          {' '}&middot; {String(row.method || '').replace('_', ' ')}
                        </span>
                      </div>
                      <span className="badge bg-primary">approve</span>
                    </Link>
                  ))}
                </Card.Body>
              </Card>
            ) : null}

            <div className="my-3">
              <h2>Sales</h2>
              {summery.dailyOrders.length === 0 ? (
                <MessageBox variant="warning">No Sales</MessageBox>
              ) : (
                <Chart
                  width="100%"
                  height="100%"
                  chartType="AreaChart"
                  loader={<div>Loading Chart...</div>}
                  data={[
                    ['Date', 'Sales'],
                    ...summery.dailyOrders.map((x) => [x._id, x.sales]),
                  ]}
                ></Chart>
              )}
            </div>
          </>
        )}
      </Container>
    </div>
  );
}
